// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_5Wsg4","red":"index_red_njcch","green":"index_green_UDj5N","price":"index_price_fMuKJ"};